import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  return <Section background="peach" data-id="element-1">
      <div className="text-center mb-12" data-id="element-2">
        <h2 className="text-3xl font-serif font-bold text-warm-dark mb-4" data-id="element-3">
          Qué vas a lograr en 14 días
        </h2>
        <p className="text-lg text-warm-dark/80" data-id="element-4">
          Señales reales de que tu metabolismo está sanando
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-5">
        {['Menos antojos (frecuencia e intensidad)', 'Menos bajón de tarde a las 3pm', 'Más control en la noche al llegar a casa', 'Menos hinchazón y ropa más cómoda', 'Decisiones más fáciles sin pelear contigo', 'Más energía estable durante el día'].map((benefit, i) => <div key={i} className="flex items-center bg-white/60 p-4 rounded-xl backdrop-blur-sm" data-id="element-6">
            <div className="bg-terracotta rounded-full p-1 mr-3" data-id="element-7">
              <Check className="w-4 h-4 text-white" data-id="element-8" />
            </div>
            <span className="text-warm-dark font-medium" data-id="element-9">{benefit}</span>
          </div>)}
      </div>

      <p className="text-center text-sm text-warm-dark/60 mt-8 max-w-2xl mx-auto italic" data-id="element-10">
        (No prometo resultados específicos de peso: cada cuerpo y contexto es
        distinto. Pero sí te doy un sistema que puedes ejecutar y sostener).
      </p>
    </Section>;
}